import React, { useEffect, useState } from "react";
import { withSnackbar } from "notistack";

import Loader from "components/Custom/Loader";
import ExcelGrid from "components/Custom/ExcelGrid";

import { LABELS, TITLES } from "common/lables";
import { CRM_REPORTS_APIs } from "apihandlers/crm/reports";
import { DateFunctions } from "common/datefunctions";
import { CRM_LEAD_STATUS, FORMATS } from "common/config";
import { selectClasses } from "@mui/material";

const EXCEL_GRID_ID = "SecondaryWeeklySummary";

const SecondaryWeeklySummary = (props: any) => {
  const { setDashMenu } = props;

  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState<any>([]);

  useEffect(() => {
    if (loading) {
      getRows();
    }
  }, [loading]);

  const getRows = async () => {
    try {
      const args = {
        fromDate: DateFunctions.getDate("thismonth", "from", FORMATS.SQL_DATE),
        toDate: DateFunctions.getDate("thismonth", "to", FORMATS.SQL_DATE),
        // fromDate: "2023-06-01",
        // toDate: "2023-06-30",
      };
      const res: any = await CRM_REPORTS_APIs.getCrmCompliance(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < response.records.length; i++) {
          list[i]["slNo"] = i + 1;

          //   if (list[i]["activeStatus"]) {
          //     list[i]["activeStatusText"] = "Yes";
          //   } else {
          //     list[i]["activeStatusText"] = "No";
          //   }
          //   if (list[i]["verifiedStatus"]) {
          //     list[i]["verifiedStatus"] = "Yes";
          //   } else {
          //     list[i]["verifiedStatus"] = "No";
          //   }
        }
        setRows(list);
        // setLoading(false);
      }
    } catch (error) {
      console.error("getLeadVisits:", error);
    }
  };

  const COLUMNS = [
    {
      key: "id",
      name: LABELS.ID,
      width: "20%",
      type: "text",
      sortable: true,
      searchable: true,
      editable: false,
    },
    {
      key: "name",
      name: LABELS.NAME,
      width: "15%",
      type: "text",
      sortable: true,
      searchable: true,
      editable: false,
    },
    {
      key: "city",
      name: LABELS.CITY,
      width: "10%",
      type: "text",
      sortable: true,
      searchable: true,
      editable: false,
    },
    {
      key: "state",
      name: LABELS.STATE,
      width: "10%",
      type: "text",
      sortable: true,
      searchable: true,
      editable: false,
    },
    {
      key: "gstNumber",
      name: LABELS.FIRM_GST,
      width: "10%",
      type: "text",
      sortable: true,
      searchable: true,
      editable: false,
    },
    {
      key: "panNumber",
      name: LABELS.PAN_NUMBER,
      width: "10%",
      type: "text",
      sortable: true,
      searchable: true,
      editable: false,
    },
    {
      key: "cinNumber",
      name: LABELS.CIN,
      width: "10%",
      type: "text",
      sortable: true,
      searchable: true,
      editable: false,
    },

    {
      key: "tanNumber",
      name: LABELS.FIRM_TAN,
      width: "10%",
      type: "text",
      sortable: true,
      searchable: true,
      editable: false,
    },
    {
      key: "fssiNumber",
      name: LABELS.FSSI_NO,
      width: "10%",
      type: "text",
      sortable: true,
      searchable: true,
      editable: false,
    },
    {
      key: "adharNumber",
      name: LABELS.AADHAR_NUMBER,
      width: "10%",
      type: "text",
      sortable: true,
      searchable: true,
      editable: false,
    },
    {
      key: "drivingLicense",
      name: LABELS.DRIVING_LICENSE,
      width: "10%",
      type: "text",
      sortable: true,
      searchable: true,
      editable: false,
    },
  ];

  const reloadGrid = () => {
    setRows([]);
    getRows();
  };

  console.log("selectedRow", rows);

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>{TITLES.CRM_REPORTS}</li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.SECONDARY_WEEKLY_SUMMARY}</li>
        </ul>
        <h4>{TITLES.SECONDARY_WEEKLY_SUMMARY}</h4>
        {/* <p>{SUB_TITLES.SECONDARY_WEEKLY_SUMMARY}</p> */}
      </div>

      <div className="grid excelGridWrapper">
        {rows ? (
          <ExcelGrid
            id={EXCEL_GRID_ID}
            height={window.innerHeight * 0.85}
            cols={COLUMNS}
            rows={rows}
            hideUnhide={true}
            freezeColumn={true}
            exportOption={true}
            newRowOption={false}
            exportName={TITLES.SECONDARY_WEEKLY_SUMMARY}
            onReload={reloadGrid}
          />
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default withSnackbar(SecondaryWeeklySummary);
